import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { FreeBetsWrapper } from '@pascal/pascal-core';
import { ExtraBets } from '../../components/extraBets';
import { WinPopup } from '../../components/winPopUp';
import { UserBets } from '../../components/userBets';
import { ExtraButton } from '../../components/extraButton';
import { RoundTimeSection } from '../../components/roundTimeSection';
import { BoxBetsAndCards } from '../../components/boxBetsAndCards';
import { DealerCards } from '../../components/dealerCards';
import { ChipActionWrapper } from '../../components/chipsActionWrapper/chipActionWrapper';
import { GameName } from '../../components/gameName';
import { winningAmountStore } from '../../store/winningAmountStore';
import gameLogo from '../../assets/images/bet-on-poker/b-o-p-logo.png';

export const MobileGameMain = observer(() => {
  const [isShowExtraBets, setIsShowExtraBets] = useState(false);
  const { winningCombination } = winningAmountStore;

  const handleShowExtraBets = useCallback(() => {
    setIsShowExtraBets((prev) => !prev);
  }, []);

  useEffect(() => {
    if (winningCombination !== null) {
      setIsShowExtraBets(false);
    }
  }, [winningCombination, setIsShowExtraBets]);

  return (
    <div className='m-bet-on-poker'>
      <div className='b-o-p-logo'>
        <img src={gameLogo} alt='' />
      </div>
      <WinPopup />
      <FreeBetsWrapper />
      <div className='m-bet-on-poker-table'>
        <RoundTimeSection />
        <BoxBetsAndCards />
        <DealerCards />
        <GameName />
        <ExtraButton handleShowExtraBets={handleShowExtraBets} />
        <ChipActionWrapper />
      </div>
      <UserBets />
      {isShowExtraBets && <ExtraBets handleShowExtraBets={handleShowExtraBets} />}
    </div>
  );
});
